export default "__VITE_ASSET__72S2Z88c__"